module.exports = __webpack_public_path__ + "static/media/shadow-attack-1.d3667e2e.png";